import React from "react";
import { SkeletonTile } from "@contentstack/venus-components";

const SelectorPageLoader: React.FC = function () {
  return (
    <div>
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={70}
        tileWidth={1500}
        tileBottomSpace={5}
        tileTopSpace={0}
        tileleftSpace={0}
        tileRadius={0}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
      <SkeletonTile
        numberOfTiles={1}
        tileHeight={200}
        tileWidth={200}
        tileBottomSpace={5}
        tileTopSpace={30}
        tileleftSpace={40}
        tileRadius={10}
      />
    </div>
  );
};
export default SelectorPageLoader;
